<template>
  <div>
    <span>{{ item.codigo }}</span> - <span>{{ item.nome }}</span>
  </div>
</template>

<script>
export default {
  props: {
    item: { required: true },
    searchText: { required: true },
  },
}

</script>
